import { debounce } from 'lodash';
import { getLoginStatus } from '../../api';
import { isSupportSystem } from '../../config';
import { RepoCrontabStatus } from '../../model';
import { CommonStatusStep } from '../../model/api-modules';
import { initIoaLogin } from '../../pages/admin/lib/ioa-helper';
import { intiLoginStep, jumpToLogin } from '../../pages/lib';
import { log } from '../log';
import { Crontab } from './crontab/crontab';
import { CrontabPool } from './crontab/crontab-pool';

const LOGOUT_INTERVAL = 2 * 60 * 1000; // 登录态过去至少2分钟后退出登录

export interface ILoginCheckCrontab {
  readonly workspaceID: number;
  readonly triggerTimes: string[];
}

export class LoginCheckCrontab {
  private crontabPool: CrontabPool | null = null;
  private lastLoginExpiredTimestamp = 0;
  private windowFocusHandler = debounce(() => {
    this.checkLogin();
  }, 1000);

  public constructor(crontabPool: CrontabPool) {
    this.crontabPool = crontabPool;
    this.init();
  }

  public async trigger(crontab: Crontab<LoginCheckCrontab>) {
    if (isSupportSystem()) {
      initIoaLogin();
      return;
    }

    const loginStep = await intiLoginStep();
    if (!loginStep) {
      log().info(
        `[Crontab] task check login status, current login timeout, ${crontab.crontabID}`
      );
    }

    await this.checkLogin();
  }

  public addCrontabPool(crontab: ILoginCheckCrontab) {
    if (this.crontabPool && crontab.workspaceID !== undefined) {
      const { workspaceID, triggerTimes } = crontab;
      const crontabID = `check-login-crontab-${workspaceID}`;
      if (!triggerTimes.length) {
        this.crontabPool.remove(crontabID);
        return;
      }
      const crontabInstance = new Crontab<LoginCheckCrontab>(
        crontabID,
        RepoCrontabStatus.Running,
        triggerTimes,
        'interval',
        this
      );
      this.crontabPool.add(crontabID, crontabInstance);
    }
  }

  public destroy() {
    this.crontabPool = null;
  }

  public init() {
    window.addEventListener('focus', this.windowFocusHandler);
  }

  private async checkLogin() {
    const res = await getLoginStatus();
    const currentTime = new Date().getTime();
    if (res === CommonStatusStep.Reject) {
      if (this.lastLoginExpiredTimestamp) {
        if (currentTime - this.lastLoginExpiredTimestamp >= LOGOUT_INTERVAL) {
          jumpToLogin();
        }
      } else {
        this.lastLoginExpiredTimestamp = currentTime;
      }
    } else if (res === CommonStatusStep.Resolve) {
      this.lastLoginExpiredTimestamp = 0;
    }
  }
}
